import React from 'react'
import DialogPicker from './DialogPicker'

const ZipPicker = props => (
  <DialogPicker width='auto' {...props} />
)

export default ZipPicker
